(function () {
  function playHeroVideo(media) {
    if (media.classList.contains("is-playing")) {
      return;
    }

    const iframe = media.querySelector("[data-single-post-hero-iframe]");
    const poster = media.querySelector("[data-single-post-hero-poster]");
    const playBtn = media.querySelector("[data-single-post-hero-play]");
    const videoWrap = media.querySelector("[data-single-post-hero-video-wrap]");

    if (!iframe) {
      return;
    }

    const src = iframe.getAttribute("data-src");

    if (src && !iframe.getAttribute("src")) {
      iframe.setAttribute("src", src);
    }

    media.classList.add("is-playing");

    if (poster) {
      poster.setAttribute("hidden", "");
    }

    if (videoWrap) {
      videoWrap.removeAttribute("hidden");
    }

    if (playBtn) {
      playBtn.setAttribute("hidden", "");
    }
  }

  function bindHeroVideo(section) {
    const media = section.querySelector("[data-single-post-hero-media]");

    if (!media || !media.classList.contains("single-post-hero__media--has-video")) {
      return;
    }

    const playBtn = media.querySelector("[data-single-post-hero-play]");
    const poster = media.querySelector("[data-single-post-hero-poster]");

    if (playBtn) {
      playBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        playHeroVideo(media);
      });
    }

    if (poster) {
      poster.addEventListener("click", function (event) {
        if (event.target.closest("[data-single-post-hero-play]")) {
          return;
        }
        playHeroVideo(media);
      });
    }
  }

  function init() {
    document.querySelectorAll("[data-single-post-hero]").forEach(bindHeroVideo);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
